<template>
	<div id="topLeft">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">项目规模</span>
				</div>
			</div>
			<div class="float-l" style="display: flex;align-items: center;width: 100%;margin-top: 0.45rem;">
				<div class="float-l" style="margin:auto;">
					<div class="float-l icon-mokuai"></div>
					<div class="float-l text ml-2">
						<p style="font-size: 0.2rem;">仓库数量<br><br><span style="font-size: 0.25rem;">{{ topLeftData.building_num }}个</span></p>
					</div>
				</div>
				<div class="float-l" style="margin:auto;">
					<div class="float-l icon-louceng"></div>
					<div class="float-l text ml-2">
						<p style="font-size: 0.2rem;">制冷面积<br><br><span style="font-size: 0.25rem;">{{ topLeftData.cooling_area }}万m²</span></p>
					</div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		components: {
			
		},
		props:['topLeftData'],
		mounted() {
			
		},
		methods: {
			
		},
	};
</script>

<style lang="scss">
	#topLeft {
		height: 2.25rem;
		width: 5.125rem;

		.text {
			display: table;
			color: white;
			width: 1rem;
			height: 0.8rem;

			p {
				width: 1rem;
				display: table-cell;
				vertical-align: middle;
			}
		}

		.icon-mokuai {
			display: inline-block;
			width: 0.8rem;
			height: 0.8rem;
			background: url('~@/assets/icon/mokuai.png') no-repeat center;
			background-size: 100%;
		}

		.icon-louceng {
			display: inline-block;
			width: 0.8rem;
			height: 0.8rem;
			background: url('~@/assets/icon/louceng.png') no-repeat center;
			background-size: 100%;
		}
	}
</style>
